const classes = {
  section: {
    display: 'grid',
    justifyContent: 'center',
    paddingTop: '6rem'
  }
}

export default classes
